export default {
  path: '/material',
  title: '好物料',
  icon: 'sitemap',
  children: [
    {
      path: 'home',
      title: '首页',
      icon: 'home',
      component: 'material/home'
    },
    {
      path: 'purchase',
      title: '采购管理',
      icon: 'file-text',
      component: 'material/purchase/material'
    },
    {
      path: 'instock',
      title: '入库管理',
      icon: 'indent',
      component: 'material/instock/list'
    },
    {
      path: 'outstock',
      title: '出库管理',
      icon: 'outdent',
      component: 'material/outstock/list'
    },
    {
      path: 'stock',
      title: '库存管理',
      icon: 'columns',
      children: [
        {
          path: 'detail',
          title: '库存明细',
          component: 'material/stock/detail'
        },
        {
          path: 'safe',
          title: '安全库存',
          component: 'material/stock/safe'
        },
        {
          path: 'inout',
          title: '收发存',
          component: 'material/stock/inout'
        }
      ]
    },
    {
      path: 'inventory',
      title: '盘点管理',
      icon: 'bar-chart',
      children: [
        {
          path: 'inventory',
          title: '库存盘点',
          component: 'material/inventory/inventory'
        },
        {
          path: 'accounting',
          title: '财务核算',
          component: 'material/inventory/accounting'
        }
      ]
    },
    {
      path: 'material',
      title: '物料管理',
      icon: 'cubes',
      children: [
        {
          path: 'classify',
          title: '分类管理',
          component: 'material/material/classify'
        },
        {
          path: 'material',
          title: '物料管理',
          component: 'material/material/material'
        }
      ]
    },
    {
      path: 'supplier',
      title: '供应商管理',
      icon: 'industry',
      children: [
        {
          path: 'type',
          title: '类型管理',
          component: 'material/supplier/type'
        },
        {
          path: 'level',
          title: '等级管理',
          component: 'material/supplier/level'
        },
        {
          path: 'pay',
          title: '付款方式',
          component: 'material/supplier/pay'
        },
        {
          path: 'time',
          title: '供货时间',
          component: 'material/supplier/time'
        },
        {
          path: 'supplier',
          title: '供应商管理',
          component: 'material/supplier/supplier'
        }
      ]
    },
    {
      path: 'basic',
      title: '基础设置',
      icon: 'cogs',
      children: [
        {
          path: 'storehouse',
          title: '仓库管理',
          component: 'material/basic/storehouse'
        },
        {
          path: 'unit',
          title: '单位管理',
          component: 'material/basic/unit'
        },
        {
          path: 'conversion',
          title: '单位转换',
          component: 'material/basic/conversion'
        },
        {
          path: 'color',
          title: '颜色管理',
          component: 'material/basic/color'
        },
        {
          path: 'colorSeries',
          title: '色系管理',
          component: 'material/basic/colorSeries'
        },
        {
          path: 'material',
          title: '材质管理',
          component: 'material/basic/material'
        },
        {
          path: 'specification',
          title: '规格管理',
          component: 'material/basic/specification'
        }
      ]
    }
  ]
}
